import axios from 'axios'
import LocalDatabase from '../utils/LocalDatabase'
import Types from '../store/types'

const main = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    /*'Access-Control-Allow-Origin':'*',*/
    Accept: 'application/json'
  }
})

// Add request interceptor to attach token dynamically
main.interceptors.request.use(
  async (config) => {
    const token = await LocalDatabase.get(Types.localdb.USER_TOKEN)
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default main
